<template>
    <TasksListComponent :title="$t('taskViews.estimatedOverdue')" :apiUrl="apiUrl" :showFilters="false" />
</template>
  
<script>
import TasksListComponent from '@/components/TasksListComponent.vue';
import { useDate } from '@/composables/useDate';

export default {
    name: 'TasksEstimatedOverdueListView',
    components: {
        TasksListComponent
    },
    computed: {
        apiUrl() {
            const baseApiUrl = 'tasks/';
            const { formatDate } = useDate();
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            const formattedDate = formatDate(yesterday);
            const params = new URLSearchParams({
                finished: '0',
                estimated_date_end: formattedDate,
                users: this.currentUser.id,
                sort_by: 'estimated_date',
                sort_order: 'asc'
            });
            return `${baseApiUrl}?${params.toString()}`;
        },
        currentUser() {
            const user = localStorage.getItem('user');
            return user ? JSON.parse(user) : null;
        }
    }
};
</script>
  